(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function track(event, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: event }, payload || {}));
  }

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function formatMoney(cents, moneyFormat) {
    var value = (Number(cents) || 0) / 100;
    var formatted = value.toFixed(2);
    var format = moneyFormat || '${{amount}}';
    if (format.indexOf('{{amount_no_decimals}}') !== -1) {
      formatted = String(Math.round(value));
    } else if (format.indexOf('{{amount_with_comma_separator}}') !== -1) {
      formatted = value.toFixed(2).replace('.', ',');
    } else if (format.indexOf('{{amount_with_apostrophe_separator}}') !== -1) {
      formatted = value.toFixed(2).replace('.', "'");
    }
    var withThousands = formatted.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, formatted)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, formatted)
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, formatted)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, formatted)
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, formatted)
      .replace(/\{\{\s*amount\s*\}\}/g, withThousands);
  }

  function parseJsonScript(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function findKachingLauncher() {
    return (
      document.querySelector('#kaching-upsell') ||
      document.querySelector('.kaching-upsell') ||
      document.querySelector('[class*="kaching" i]') ||
      document.querySelector('[id*="kaching" i]') ||
      document.querySelector('iframe[src*="kaching"]')
    );
  }

  function offsetStickyForKaching(root, sticky) {
    if (!sticky) return;
    var offset = 0;
    var launcher = findKachingLauncher();
    if (launcher) {
      var rect = launcher.getBoundingClientRect();
      var style = window.getComputedStyle(launcher);
      var visible =
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        rect.height > 8 &&
        rect.bottom >= window.innerHeight - 16;
      if (visible && rect.width > window.innerWidth * 0.5) {
        offset = Math.ceil(rect.height) + 8;
      }
    }
    sticky.style.setProperty('--gg-kaching-offset', offset + 'px');
  }

  function openCartDrawer(data) {
    var cart = document.querySelector('cart-drawer');
    if (typeof publish === 'function') {
      publish(
        (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) || 'cart-update',
        { source: 'gg-pdp', cartData: data }
      );
    }
    if (cart && typeof cart.renderContents === 'function' && data && data.sections) {
      cart.renderContents(data, true);
      return;
    }
    document.dispatchEvent(
      new CustomEvent('cart-drawer:refresh', { detail: { response: data }, bubbles: true, composed: true })
    );
  }

  function init(root) {
    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
    var variants = parseJsonScript(qs('[data-gg-variants-json]', root)) || [];
    var media = parseJsonScript(qs('[data-gg-media-json]', root)) || [];
    var variantById = {};
    variants.forEach(function (v) {
      variantById[String(v.id)] = v;
    });

    var idInput = qs('[data-gg-variant-id]', root);
    var priceEl = qs('[data-gg-price]', root);
    var compareEl = qs('[data-gg-compare]', root);
    var saveEl = qs('[data-gg-save]', root);
    var atc = qs('[data-gg-atc]', root);
    var atcLabel = atc ? qs('[data-gg-atc-label]', atc) : null;
    var sticky = qs('[data-gg-sticky]', root);
    var stickyTitle = qs('[data-gg-sticky-title]', root);
    var stickyPrice = qs('[data-gg-sticky-price]', root);
    var stickyAtc = qs('[data-gg-sticky-atc]', root);
    var stickyAtcLabel = stickyAtc ? qs('[data-gg-sticky-atc-label]', stickyAtc) : null;
    var stickyImg = qs('[data-gg-sticky-img]', root);
    var form = qs('[data-gg-form]', root) || qs('form[data-type="add-to-cart-form"]', root);
    var qtyInput = form ? qs('[name="quantity"]', form) : null;
    var stageImg = qs('[data-gg-stage-img]', root);
    var stage = qs('[data-gg-stage]', root);
    var thumbs = qsa('[data-gg-thumb]', root);
    var zoom = qs('[data-gg-zoom]', root);
    var zoomImg = qs('[data-gg-zoom-img]', root);
    var currentId = idInput ? idInput.value : '';

    function money(cents) {
      return formatMoney(cents, moneyFormat);
    }

    function currentVariant() {
      return variantById[String(currentId)] || variants[0] || null;
    }

    function setStageFromMedia(item, eager) {
      if (!stageImg || !item) return;
      stageImg.src = item.src;
      stageImg.srcset = item.srcset || '';
      stageImg.sizes = item.sizes || stageImg.sizes;
      stageImg.alt = item.alt || '';
      stageImg.setAttribute('data-zoom', item.zoom || item.src);
      stageImg.setAttribute('width', item.width || 1100);
      stageImg.setAttribute('height', item.height || 1100);
      if (eager) {
        stageImg.setAttribute('fetchpriority', 'high');
        stageImg.setAttribute('loading', 'eager');
      }
      thumbs.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-media-id') === String(item.id));
      });
      if (stickyImg && item.src) stickyImg.src = item.src;
    }

    function mediaById(id) {
      if (!id) return null;
      for (var i = 0; i < media.length; i++) {
        if (String(media[i].id) === String(id)) return media[i];
      }
      return null;
    }

    function sellingPlanId() {
      var nodes = [];
      var widget = qs('[data-gg-subs]', root);
      if (widget) nodes.push(widget);
      if (form) nodes.push(form);
      nodes.push(root);
      for (var i = 0; i < nodes.length; i++) {
        var checked = nodes[i].querySelector('input[name="selling_plan"]:checked');
        if (checked && checked.value && checked.value !== '0') return String(checked.value);
        var select = nodes[i].querySelector('select[name="selling_plan"]');
        if (select && select.value && select.value !== '0') return String(select.value);
        var hidden = nodes[i].querySelector('input[name="selling_plan"][type="hidden"]');
        if (hidden && hidden.value && hidden.value !== '0') return String(hidden.value);
      }
      return '';
    }

    function sellingPlanSelected() {
      if (sellingPlanId()) return true;
      var widget = qs('[data-gg-subs]', root);
      if (widget) {
        if (widget.querySelector('[class*="onetime"].is-selected, [class*="one-time"].is-selected, [class*="onetime"].is-active, [aria-checked="true"][class*="onetime"]')) {
          return false;
        }
        if (widget.querySelector('[class*="subscription"].is-selected, [class*="subscribe"].is-selected, [class*="subscription"].is-active')) {
          return true;
        }
      }
      return false;
    }

    function displayPrice(variant) {
      if (!variant) return 0;
      var oneTime = Number(variant.price) || 0;
      if (!sellingPlanSelected()) return oneTime;
      var allocs = variant.selling_plan_allocations || [];
      var planId = sellingPlanId();
      var i;
      if (planId) {
        for (i = 0; i < allocs.length; i++) {
          if (String(allocs[i].selling_plan_id) === planId) return Number(allocs[i].price) || oneTime;
        }
      }
      if (allocs.length) return Number(allocs[0].price) || oneTime;
      return oneTime;
    }

    function updatePillPrices() {
      qsa('[data-gg-variant]', root).forEach(function (input) {
        var variant = variantById[String(input.value)];
        if (!variant) return;
        var pill = input.closest('.gg-pdp__pill');
        if (!pill) return;
        var cents = displayPrice(variant);
        var priceNode = pill.querySelector('[data-gg-pill-price]');
        var ozNode = pill.querySelector('[data-gg-pill-oz]');
        if (priceNode) priceNode.textContent = money(cents);
        var oz = Number(input.getAttribute('data-oz') || variant.oz || 0);
        if (ozNode && oz > 0) ozNode.textContent = money(Math.round(cents / oz)) + ' / oz';
      });
    }

    var applyingAtcLabel = false;
    function updateAtcLabel() {
      if (applyingAtcLabel || !atc) return;
      applyingAtcLabel = true;
      var variant = currentVariant();
      var available = !!(variant && variant.available);
      var text = atc.getAttribute('data-label-sold');
      if (available) {
        text = sellingPlanSelected()
          ? atc.getAttribute('data-label-subscribe')
          : atc.getAttribute('data-label-add');
      }
      if (atcLabel && atcLabel.textContent !== text) atcLabel.textContent = text;
      if (stickyAtcLabel && stickyAtcLabel.textContent !== text) stickyAtcLabel.textContent = text;
      applyingAtcLabel = false;
    }

    function updateAvailability(variant) {
      var available = !!(variant && variant.available);
      if (atc) atc.disabled = !available;
      if (stickyAtc) stickyAtc.disabled = !available;
      updateAtcLabel();
    }

    function syncSubscriptionWidget(variant) {
      if (!variant) return;
      qsa('input[name="id"]', root).forEach(function (input) {
        input.value = variant.id;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      var widget = qs('[data-gg-subs]', root);
      if (widget) {
        qsa('input[name="id"], input[name="variant_id"], select[name="id"]', widget).forEach(function (input) {
          input.value = variant.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
      if (typeof publish === 'function') {
        publish((typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) || 'variant-change', {
          data: { sectionId: root.getAttribute('data-section-id'), variant: variant },
        });
      }
      document.dispatchEvent(
        new CustomEvent('variant:change', { bubbles: true, detail: { variant: variant, variantId: variant.id } })
      );
    }

    function selectVariant(variant, opts) {
      if (!variant) return;
      currentId = String(variant.id);
      if (idInput) idInput.value = variant.id;

      qsa('[data-gg-variant]', root).forEach(function (input) {
        var on = input.value === String(variant.id);
        input.checked = on;
        var pill = input.closest('.gg-pdp__pill');
        if (pill) pill.classList.toggle('is-selected', on);
      });

      if (priceEl) priceEl.textContent = money(displayPrice(variant));
      if (compareEl) {
        var shownPrice = displayPrice(variant);
        var compareAt = Number(variant.compare_at_price) || 0;
        if (sellingPlanSelected() && Number(variant.price) > shownPrice) compareAt = Number(variant.price);
        var showCompare = compareAt && compareAt > shownPrice;
        compareEl.hidden = !showCompare;
        if (showCompare) compareEl.textContent = money(compareAt);
        if (saveEl) {
          var pct = showCompare ? Math.round((1 - shownPrice / compareAt) * 100) : 0;
          saveEl.hidden = !showCompare || pct < 1;
          if (pct >= 1) saveEl.textContent = pct + '% off';
        }
      }
      if (stickyTitle) stickyTitle.textContent = variant.title;
      if (stickyPrice) stickyPrice.textContent = money(displayPrice(variant));
      updatePillPrices();

      updateAvailability(variant);

      var featured = mediaById(variant.featured_media_id);
      if (featured) setStageFromMedia(featured, false);

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        history.replaceState({}, '', url.toString());
      } catch (e) {}

      syncSubscriptionWidget(variant);
      updateRitualTotal();
      updateAtcLabel();

      if (!opts || !opts.silent) {
        track('variant_select', { variant_title: variant.title, variant_id: variant.id });
      }
    }

    qsa('[data-gg-variant]', root).forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.disabled) return;
        selectVariant(variantById[input.value]);
      });
    });

    function updateRitualTotal() {
      var totalEl = qs('[data-gg-ritual-total]', root);
      if (!totalEl) return;
      var variant = currentVariant();
      var total = variant ? Number(variant.price) : 0;
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      total = total * qty;
      qsa('[data-gg-addon]', root).forEach(function (box) {
        if (box.checked) total += Number(box.getAttribute('data-price') || 0);
      });
      totalEl.textContent = money(total);
    }

    qsa('[data-gg-addon]', root).forEach(function (box) {
      box.addEventListener('change', function () {
        updateRitualTotal();
        track('addon_toggle', {
          product_handle: box.getAttribute('data-handle') || '',
          checked: box.checked,
        });
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', updateRitualTotal);
    if (qtyInput) qtyInput.addEventListener('input', updateRitualTotal);

    var ritualBtn = qs('[data-gg-ritual-submit]', root);
    if (ritualBtn) {
      ritualBtn.addEventListener('click', function () {
        var variant = currentVariant();
        if (!variant || !variant.available) return;
        var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
        var items = [{ id: Number(variant.id), quantity: qty }];
        var total = Number(variant.price) * qty;
        qsa('[data-gg-addon]', root).forEach(function (box) {
          if (!box.checked) return;
          var addonId = Number(box.getAttribute('data-variant-id'));
          var addonPrice = Number(box.getAttribute('data-price') || 0);
          if (addonId) {
            items.push({ id: addonId, quantity: 1 });
            total += addonPrice;
          }
        });
        var cart = document.querySelector('cart-drawer');
        var sections = ['cart-drawer', 'cart-icon-bubble'];
        try {
          if (cart && typeof cart.getSectionsToRender === 'function') {
            sections = cart.getSectionsToRender().map(function (s) {
              return s.id;
            });
          }
        } catch (e) {}
        ritualBtn.disabled = true;
        fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items, sections: sections, sections_url: location.pathname }),
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (data) {
            if (data && data.status) return;
            track('add_ritual_to_cart', { items: items, value: total / 100 });
            openCartDrawer(data);
          })
          .catch(function () {})
          .finally(function () {
            ritualBtn.disabled = false;
          });
      });
    }

    qsa('details[data-gg-acc]', root).forEach(function (acc) {
      acc.addEventListener('toggle', function () {
        if (acc.open) track('accordion_open', { label: acc.getAttribute('data-gg-acc') || '' });
      });
    });

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = mediaById(btn.getAttribute('data-media-id'));
        setStageFromMedia(item, false);
      });
    });

    function isDesktop() {
      return window.matchMedia('(min-width: 750px)').matches;
    }

    if (stage && stageImg) {
      var startX = 0;
      var startY = 0;
      var pinchStart = 0;
      var scale = 1;

      stage.addEventListener('click', function (e) {
        if (!isDesktop() || !zoom || !zoomImg) return;
        if (e.target.closest('button')) return;
        zoomImg.src = stageImg.getAttribute('data-zoom') || stageImg.src;
        zoom.hidden = false;
      });

      stage.addEventListener(
        'touchstart',
        function (e) {
          if (e.touches.length === 1) {
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
          } else if (e.touches.length === 2) {
            var dx = e.touches[0].clientX - e.touches[1].clientX;
            var dy = e.touches[0].clientY - e.touches[1].clientY;
            pinchStart = Math.hypot(dx, dy);
          }
        },
        { passive: true }
      );

      stage.addEventListener(
        'touchmove',
        function (e) {
          if (e.touches.length === 2 && pinchStart) {
            var dx = e.touches[0].clientX - e.touches[1].clientX;
            var dy = e.touches[0].clientY - e.touches[1].clientY;
            scale = Math.min(3, Math.max(1, Math.hypot(dx, dy) / pinchStart));
            stageImg.style.transform = 'scale(' + scale + ')';
          }
        },
        { passive: true }
      );

      stage.addEventListener('touchend', function (e) {
        if (e.touches.length === 0 && scale <= 1.05) {
          var dx = (e.changedTouches[0] && e.changedTouches[0].clientX - startX) || 0;
          if (Math.abs(dx) > 40) {
            var active = qs('.gg-pdp__thumb.is-active', root);
            var list = thumbs;
            var idx = list.indexOf(active);
            var next = dx < 0 ? idx + 1 : idx - 1;
            if (next >= 0 && next < list.length) list[next].click();
          }
        }
        if (e.touches.length < 2) {
          pinchStart = 0;
          scale = 1;
          stageImg.style.transform = '';
        }
      });
    }

    if (zoom) {
      zoom.addEventListener('click', function () {
        zoom.hidden = true;
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !zoom.hidden) zoom.hidden = true;
      });
    }

    var stars = qs('[data-gg-stars]', root);
    if (stars) {
      stars.addEventListener('click', function (e) {
        var link = e.target.closest('a');
        if (!link) return;
        var target = document.getElementById('judgeme_product_reviews');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    var reviewsSlot = qs('[data-gg-reviews-slot]', root);
    if (reviewsSlot) {
      var widget =
        document.querySelector('.jdgm-rev-widg') ||
        document.querySelector('.jdgm-review-widget') ||
        document.querySelector('#judgeme_product_reviews');
      var sectionEl = widget && widget.closest('[id^="shopify-section-"]');
      if (!sectionEl) {
        qsa('[id^="shopify-section-"]').some(function (sec) {
          if (sec.querySelector('.jdgm-rev-widg, .jdgm-review-widget')) {
            sectionEl = sec;
            return true;
          }
          return false;
        });
      }
      if (sectionEl && !reviewsSlot.contains(sectionEl)) {
        reviewsSlot.appendChild(sectionEl);
      }
      if (!document.getElementById('judgeme_product_reviews')) {
        reviewsSlot.id = 'judgeme_product_reviews';
      }
    }

    if (sticky && atc && window.IntersectionObserver) {
      var seenAtc = false;
      var io = new IntersectionObserver(
        function (entries) {
          var vis = entries[0] && entries[0].isIntersecting;
          if (vis) seenAtc = true;
          var mobile = window.matchMedia('(max-width: 749px)').matches;
          sticky.classList.toggle('is-on', mobile && seenAtc && !vis);
          offsetStickyForKaching(root, sticky);
        },
        { threshold: 0 }
      );
      io.observe(atc);
      offsetStickyForKaching(root, sticky);
      window.addEventListener('resize', function () {
        if (!window.matchMedia('(max-width: 749px)').matches) sticky.classList.remove('is-on');
        offsetStickyForKaching(root, sticky);
      });
    }

    if (stickyAtc && form) {
      stickyAtc.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(atc);
        else form.submit();
      });
    }

    var initial = currentVariant();
    if (initial) selectVariant(initial, { silent: true });
    updateRitualTotal();
    updateAtcLabel();

    var subsRoot = qs('[data-gg-subs]', root);
    function onSubsChange() {
      window.setTimeout(function () {
        updateAtcLabel();
        updatePillPrices();
        var variant = currentVariant();
        if (!variant) return;
        if (priceEl) priceEl.textContent = money(displayPrice(variant));
        if (stickyPrice) stickyPrice.textContent = money(displayPrice(variant));
        if (compareEl) {
          var shownPrice = displayPrice(variant);
          var compareAt = Number(variant.compare_at_price) || 0;
          if (sellingPlanSelected() && Number(variant.price) > shownPrice) compareAt = Number(variant.price);
          var showCompare = compareAt && compareAt > shownPrice;
          compareEl.hidden = !showCompare;
          if (showCompare) compareEl.textContent = money(compareAt);
        }
      }, 0);
    }
    if (subsRoot) {
      subsRoot.addEventListener('change', onSubsChange);
      subsRoot.addEventListener('click', onSubsChange);
      if (window.MutationObserver) {
        new MutationObserver(onSubsChange).observe(subsRoot, {
          subtree: true,
          childList: true,
          attributes: true,
        });
      }
    }
    if (form) form.addEventListener('change', onSubsChange);
    if (atc && window.MutationObserver) {
      new MutationObserver(function () {
        if (!applyingAtcLabel) updateAtcLabel();
      }).observe(atc, { subtree: true, childList: true, characterData: true });
    }
    window.setTimeout(onSubsChange, 400);
    window.setTimeout(onSubsChange, 1200);
  }

  onReady(function () {
    qsa('[data-gg-pdp]').forEach(init);
  });
})();
